import type { ComponentProps } from 'react';
import React from 'react';
import { StyleSheet, View } from 'react-native';

import { TYPE_CONFIG, theme } from '@garnish/constants';

import { IconLink } from '../../../Icon';
import { DisplayText } from '../../../Text';
import type { PaletteProps } from '../../Modal.types';

export const ModalHeader = (
  props: ComponentProps<typeof DisplayText> &
    PaletteProps & { readonly onClose: () => void },
) => {
  const { children, palette, onClose, ...restProps } = props;

  const paletteSpecificTextStyles = palette
    ? paletteHeadingTextStyles[palette]
    : undefined;
  const textStyles = [styles.fontSizeDisplay32, paletteSpecificTextStyles];

  return (
    <View style={styles.header}>
      <DisplayText style={textStyles} {...restProps}>
        {children}
      </DisplayText>

      <IconLink
        testID="sg-modal-close-btn"
        name="IconClose"
        accessibilityRole="button"
        accessibilityLabel="close dialog"
        onPress={onClose}
      />
    </View>
  );
};

// ─── Styles ────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing['6'],
  },
  headlineSecondary: {
    color: theme.colors.WHITE,
  },
  fontSizeDisplay32: {
    ...TYPE_CONFIG.DISPLAY['32'],
  },
});

// ─── Palette Styles ────────────────────────────────────────────────────

const paletteHeadingTextStyles = {
  primary: undefined,
  neutral: undefined,
  secondary: styles.headlineSecondary,
  lime: styles.headlineSecondary,
};
